import React, {useEffect,useState, useContext} from "react";
import { DataContext } from "contexts/DataContext";
import { assessmentList, assessmentListColumns } from "./api";

import EditableGrid from "components/EditableGrid/EditableGrid";
import { GridColDef } from '@mui/x-data-grid';

import 'i18n/config';
import { useTranslation } from 'react-i18next';

interface AssessmentListProps {
    currentOrganization: string;
}

const AssessmentList = (props: AssessmentListProps) => {
    const dataContext = useContext(DataContext);
    const [columns, setColumns] = useState([] as GridColDef[]);

  useEffect(() => {
    dataContext.changeShowLoader(true);
    if(dataContext.loading) return;
    if(!dataContext.currentOrganization) return;

    assessmentListColumns(dataContext.language).then((response:any) => {
      setColumns(response);
      dataContext.changeShowLoader(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataContext.language]);

    return (
      <EditableGrid
        showGridToolbar={false}
        key={props.currentOrganization} 
        editControls={false}
        columns={columns} 
        get={()=>assessmentList(props.currentOrganization)}
        name='assessmentListGrid'
        initialPageSize={5}
        />
    )
}

export default AssessmentList